export default {
  headerContent: {
    title: 'Ray Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Ray Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Yaşamdaki belirsizliklere karşı güvence sunan ferdi kaza sigortası, yapıldığı takdirde çoğu kaza sonrası durum için hayat kurtarıcı olmaktadır. Çünkü yaşamdaki ani ve beklenmedik kazalar ekonomik sıkıntılar yaratabilir ve bu maddi zorlukların aşılması oldukça uzun vakitler alabilir. Ferdi kaza sigortası ile kötü durumlara karşı önlem alındığı gibi sigortalı kişinin yakınlarına da güvence verilmektedir.',
        '<strong>Ray Sigorta ferdi kaza sigortası</strong> sigortalı kişinin ani kazalar sonucunda düştüğü durumlarda maddi kolaylık sağlayan sigorta türüdür. Böylece kazaların yarattığı ekonomik güçlükler engellenmektedir. Poliçe kapsamında belirtilen sınırlar dahilinde sigortalı kişiye ya da belirlediği yakınlarına tazminat ödemesi yapılır.'
      ]
    },
    subContent: {
      title: 'Ray Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası belirli durumlar dışında neredeyse çoğu kaza durumunda geçerlidir. Bu kazalar trafikte karşılaşılan kazalar kadar herhangi bir kas yıpranmasına kadar geniş bir skala içerisindedir. Kaza kapsamları sigortalı tarafından da belirlenebilmektedir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray  Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
